// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
//
// Call this once and reuse the returned function. Creating a new one per
// event (`debounce(fn, wait)()`) gives every call its own timer and so
// debounces nothing.

export default function (callback, wait, immediate) {
    let timeout

    return function () {
        const context = this
        const callNow = immediate && timeout === undefined

        clearTimeout(timeout)
        timeout = window.setTimeout(() => {
            timeout = undefined
            if (!immediate) callback.apply(context)
        }, wait)

        if (callNow) callback.apply(context)
    }
}
